import { render, staticRenderFns } from "./CreateProcedure.vue?vue&type=template&id=7416b6df&"
import script from "./CreateProcedure.vue?vue&type=script&lang=js&"
export * from "./CreateProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports